module.exports = __webpack_public_path__ + "img/checkButton.08957b8c.png";